// @ts-nocheck
import getColor from "@insite/mobius/utilities/getColor";
import {
    formFieldDescriptionWrapperStyles,
    formFieldInputSelectDisabledStyles,
    formFieldInputSelectIconStyles,
    formFieldLabelStyles,
    formFieldVariantStyles,
} from "@store/Themes/common/mixins/formField";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { css } from "styled-components";

/* ------------------------------------------------------------------------------------------ */
/* Related Extensions => src/Extensions/Mobius/FormField ------------------------------------ */
/* ------------------------------------------------------------------------------------------ */

const formField: Styleguide["formField"] = {
    defaultProps: {
        border: "rounded",
        backgroundColor: "common.background",
        labelProps: {
            css: formFieldLabelStyles(),
        },
        errorProps: {
            color: "danger",
            size: "inherit",
            weight: "inherit",
        },
        hintProps: {
            color: "text.accent",
            size: "inherit",
            weight: "normal",
        },
        cssOverrides: {
            inputSelect: css`
                ${formFieldVariantStyles()}
                ${formFieldInputSelectIconStyles("primary", "primary.dark")}
                ${formFieldInputSelectDisabledStyles("text.disabled", "common.disabled")}
                color: ${getColor("text.input")};
            `,
            descriptionWrapper: formFieldDescriptionWrapperStyles(),
        },
    },
};

export default formField;
